import axiosClient from '../axiosClient';

const comboServiceAPI = {
    async getListComboServiceAPI(params) {
        const url = `/combo_service`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getOneComboServiceAPI(id, params) {
        const url = `/combo_service/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },

    async getListComboServiceOfUserAPI() {
        const url = `/combo_service/user_buy_combo`;
        const resp = await axiosClient.get(url);
        return resp;
    },
};

export default comboServiceAPI;
